import React, { useState, useEffect } from "react";
import {
  Users,
  ListChecks,
  Bell,
  Image as ImageIcon,
  UserPlus,
  ClipboardList,
  LogOut,
  ChevronDown,
  Search,
  Plus,
  FileSpreadsheet,
  Mail,
  Trash2,
  Pencil,
  Send,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import '../Styles/dashboard.css';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

import Attendees from "./Attendees";
import CollaborateList from "../pages/CollaborateList";
import Dashgallery from "./Dashgallery";
import CommunityMember from "./communitymember";
import SubscriberList from "./subscriberlist";
import DashboardFrontPage from "../pages/dashboardfrontpage";




// Change this if your backend runs on a different host/port
const API_BASE_URL = "";

const NAV = [
  {
    section: null,
    items: [
      {
        label: "Dashboard",
        icon: "/assets/dash_icon.png",
        isImage: true,
      },
    ],
  },
  {
    section: "Community",
    items: [
      { label: "Community Members List", icon: "/assets/commu.png", isImage: true },
      { label: "Collaborate List", icon: "/assets/collab.png", isImage: true },
      { label: "Subscribers", icon: "/assets/sub.png", isImage: true },
    ],
  },
  {
    section: "Gallery",
    items: [{ label: "Upload Event Photos", icon: "/assets/up.png", isImage: true }],
  },
  {
    section: "HR Events 2026",
    items: [
      {
        label: "Registration List",
        icon: "/assets/register.png",
        isImage: true,
        active: true,
        expandable: true,
      },
      { label: "Attendees List", icon: "/assets/attend.png", isImage: true, expandable: true },
    ],
  },
];

export default function RegisteredUsersDashboard() {
  
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
const [activePage, setActivePage] = useState(
  () => localStorage.getItem("hrd_activePage") || "dashboard"
);

const [registrationOpen, setRegistrationOpen] = useState(false);
const [selectedRegistrationEvent, setSelectedRegistrationEvent] =
  useState("confluence");
  const [attendeesOpen, setAttendeesOpen] = useState(false);
const [selectedAttendeesEvent, setSelectedAttendeesEvent] = useState("confluence");
  // Add this near your other state


  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  

  // ---- Pagination state ----
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  // Track per-row "sending..." state for the Send Confirmation button
  const [sendingId, setSendingId] = useState(null);

  // ---- Bulk send state ----
  const [bulkSending, setBulkSending] = useState(false);

  // ---- Bulk delete state ----
  const [bulkDeleting, setBulkDeleting] = useState(false);

  // ---- Edit modal state ----
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE_URL}/api/registrations`);
      if (!res.ok) throw new Error("Failed to load registered users");
      const data = await res.json();
      setUsers(data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Could not load registrations. Is the backend running?");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  useEffect(() => {
    localStorage.setItem("hrd_activePage", activePage);
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("hrd_regOpen", registrationOpen);
  }, [registrationOpen]);

  useEffect(() => {
    localStorage.setItem("hrd_regEvent", selectedRegistrationEvent);
  }, [selectedRegistrationEvent]);

  useEffect(() => {
    localStorage.setItem("hrd_attOpen", attendeesOpen);
  }, [attendeesOpen]);

  useEffect(() => {
    localStorage.setItem("hrd_attEvent", selectedAttendeesEvent);
  }, [selectedAttendeesEvent]);

  const filteredUsers = users.filter((u) =>
    u.fullName?.toLowerCase().includes(query.toLowerCase())
  );

  // Reset to page 1 whenever the search query or page size changes,
  // so the user doesn't land on an empty/out-of-range page.
  useEffect(() => {
    setCurrentPage(1);
  }, [query, pageSize]);

  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / pageSize));

  // Clamp currentPage if the dataset shrinks (e.g. after a delete)
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Builds a compact page-number list with ellipses for large page counts
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) pages.push("dots-start");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("dots-end");

    pages.push(totalPages);
    return pages;
  };

  const toggleAll = () => {
    setSelectAll((v) => !v);
    setSelected(selectAll ? [] : filteredUsers.map((u) => u.id));
  };

  const toggleOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

const handleSendConfirmation = async (id) => {
  setSendingId(id);
  try {
    const res = await fetch(`${API_BASE_URL}/api/registrations/${id}/resend-email`, {
      method: "POST",
    });
    if (!res.ok) throw new Error("Failed to resend email");
    await fetchUsers();

    Swal.fire({
      icon: 'success',
      title: 'Confirmation Sent!',
      text: 'The confirmation email has been sent successfully.',
      confirmButtonColor: '#2f6fed',
    });
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: 'error',
      title: 'Failed to Send',
      text: 'Could not send the confirmation email. Please try again.',
      confirmButtonColor: '#e0432c',
    });
  } finally {
    setSendingId(null);
  }
};
  const handleBulkSendEmail = async () => {
  if (selected.length === 0) {
    Swal.fire({
      icon: "info",
      title: "No Selection",
      text: "Please select at least one registration using the checkboxes.",
      confirmButtonColor: "#2f6fed",
    });
    return;
  }

  const result = await Swal.fire({
    icon: "question",
    title: "Send Bulk Email?",
    text: `Send confirmation email to ${selected.length} selected registration(s)?`,
    showCancelButton: true,
    confirmButtonText: "Yes, send it",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#3D44B1",
    cancelButtonColor: "#6b7086",
  });

  if (!result.isConfirmed) return;

  setBulkSending(true);

  try {
    const res = await fetch(
      `${API_BASE_URL}/api/registrations/bulk-send-email`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ids: selected,
        }),
      }
    );

    const data = await res.json();

    console.log("Bulk email response:", data);

    if (!res.ok) {
      throw new Error(
        data.error || "Failed to start bulk emails"
      );
    }

    // Clear selected users
    setSelected([]);
    setSelectAll(false);

    // Refresh registration list
    await fetchUsers();

    // Show successful message
    Swal.fire({
      icon: "success",
      title: "Bulk Email Started!",
      text: data.message,
      confirmButtonColor: "#2f6fed",
    });

  } catch (err) {
    console.error("Bulk email error:", err);

    Swal.fire({
      icon: "error",
      title: "Failed to Send",
      text: err.message || "Could not start bulk emails. Please try again.",
      confirmButtonColor: "#e0432c",
    });

  } finally {
    setBulkSending(false);
  }
};

 const handleBulkDelete = async () => {
  if (selected.length === 0) {
    Swal.fire({
      icon: 'info',
      title: 'No Selection',
      text: 'Please select at least one registration using the checkboxes.',
      confirmButtonColor: '#2f6fed',
    });
    return;
  }

  const result = await Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: `Do you want to delete ${selected.length} selected registration(s)? This cannot be undone.`,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete them',
    cancelButtonText: 'No, keep them',
    confirmButtonColor: '#e0432c',
    cancelButtonColor: '#6b7086',
  });

  if (!result.isConfirmed) return;

  setBulkDeleting(true);
  try {
    const res = await fetch(`${API_BASE_URL}/api/registrations/bulk-delete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ids: selected }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Failed to delete selected registrations");

    setUsers((prev) => prev.filter((u) => !selected.includes(u.id)));
    setSelected([]);
    setSelectAll(false);

    Swal.fire({
      icon: 'success',
      title: 'Deleted!',
      text: `${data.deletedCount} registration(s) have been deleted.`,
      confirmButtonColor: '#2f6fed',
    });
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: 'error',
      title: 'Failed to Delete',
      text: 'Could not delete the selected registrations. Please try again.',
      confirmButtonColor: '#e0432c',
    });
  } finally {
    setBulkDeleting(false);
  }
};
const handleExportToExcel = () => {
  if (filteredUsers.length === 0) {
    Swal.fire({
      icon: 'info',
      title: 'No Data',
      text: 'There are no registrations to export.',
      confirmButtonColor: '#2f6fed',
    });
    return;
  }

  const exportData = filteredUsers.map((u, index) => ({
    "S.No": index + 1,
    "Full Name": u.fullName || "",
    "Designation": u.designation || "",
    "Company": u.company || "",
    "Contact": u.contact || "",
    "Personal Email": u.personalEmail || "",
    "Official Email": u.officialEmail || "",
    "Email Sent": u.confirmationSent ? "Sent" : "Unsent",
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

  worksheet["!cols"] = [
    { wch: 6 },
    { wch: 22 },
    { wch: 20 },
    { wch: 22 },
    { wch: 15 },
    { wch: 28 },
    { wch: 28 },
    { wch: 12 },
  ];

  const dateStr = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `Registered_Users_${dateStr}.xlsx`);
};

  const handleDelete = async (id) => {
  const result = await Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: 'Do you want to delete this registration? This cannot be undone.',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'No, keep it',
    confirmButtonColor: '#e0432c',
    cancelButtonColor: '#6b7086',
  });

  if (!result.isConfirmed) return;

  try {
    const res = await fetch(`${API_BASE_URL}/api/registrations/${id}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to delete");
    setUsers((prev) => prev.filter((u) => u.id !== id));

    Swal.fire({
      icon: 'success',
      title: 'Deleted!',
      text: 'The registration has been deleted.',
      confirmButtonColor: '#2f6fed',
    });
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: 'error',
      title: 'Failed to Delete',
      text: 'Could not delete the registration. Please try again.',
      confirmButtonColor: '#e0432c',
    });
  }
};
  // ---- Edit modal handlers ----
  const openEditModal = (user) => {
    setEditingUser(user);
    setEditForm({
      fullName: user.fullName || "",
      designation: user.designation || "",
      company: user.company || "",
      contact: user.contact || "",
      personalEmail: user.personalEmail || "",
      officialEmail: user.officialEmail || "",
    });
  };

  const closeEditModal = () => {
    setEditingUser(null);
    setEditForm({});
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/registrations/${editingUser.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fullName: editForm.fullName,
          designation: editForm.designation,
          company: editForm.company,
          contactNumber: editForm.contact,
          personalEmail: editForm.personalEmail,
          officialEmail: editForm.officialEmail,
        }),
      });
      if (!res.ok) throw new Error("Failed to update registration");
      await fetchUsers();
      closeEditModal();
    } catch (err) {
      console.error(err);
      alert("Failed to save changes. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const total = users.length;
 const emailsSentCount = users.filter((u) => u.confirmationSent).length;

  return (
    <div className="hrd-app">
      {/* ---------------- Sidebar ---------------- */}
      <aside className="hrd-sidebar">
        <div className="hrd-brand">
          <img src="/assets/vana.png" alt="Vanakkam HRD" className="hrd-logo" />
        </div>

       <nav className="hrd-nav">
  {NAV.map((group, gi) => (
    <div className="hrd-nav-group" key={gi}>
      {group.section && <div className="hrd-nav-label">{group.section}</div>}
      {group.items.map((item) => (
        <React.Fragment key={item.label}>

          <button
            className={`hrd-nav-item ${
              activePage === "dashboard" && item.label === "Dashboard"
                ? "active"
                : activePage === "registration" && item.label === "Registration List"
                ? "active"
                : (activePage === "attendees" || activePage === "attendees-festival") &&
                  item.label === "Attendees List"
                ? "active"
                : activePage === "collaborate" && item.label === "Collaborate List"
                ? "active"
                : activePage === "gallery" && item.label === "Upload Event Photos"
                ? "active"
                : activePage === "community" && item.label === "Community Members List"
                ? "active"
                : activePage === "subscribers" && item.label === "Subscribers"
                ? "active"
                : ""
            }`}
            onClick={() => {
              if (item.label === "Dashboard") {
                setActivePage("dashboard");
            } else if (item.label === "Registration List") {
  setRegistrationOpen((prev) => !prev);
} else if (item.label === "Attendees List") {
  setAttendeesOpen((prev) => !prev);
} else if (item.label === "Collaborate List") {
                setActivePage("collaborate");
              } else if (item.label === "Upload Event Photos") {
                setActivePage("gallery");
              } else if (item.label === "Community Members List") {
                setActivePage("community");
              } else if (item.label === "Subscribers") {
                setActivePage("subscribers");
              }
            }}
          >
            {item.isImage ? (
              <img src={item.icon} alt={item.label} className="hrd-nav-icon-img" />
            ) : (
              <item.icon size={16} strokeWidth={2} />
            )}

            <span>{item.label}</span>

            {item.expandable && (
              <ChevronDown
                size={14}
                className={`hrd-nav-chevron ${
                  (item.label === "Registration List" && registrationOpen) ||
                  (item.label === "Attendees List" && attendeesOpen)
                    ? "open"
                    : ""
                }`}
              />
            )}
          </button>

          {/* Registration Dropdown */}
         {item.label === "Registration List" && (
  <div className={`hrd-registration-submenu ${registrationOpen ? "open" : ""}`}>
              <button
                className={`hrd-registration-subitem ${
                  selectedRegistrationEvent === "confluence" && activePage === "registration"
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setSelectedRegistrationEvent("confluence");
                  setActivePage("registration");
                }}
              >
                <span className="hrd-submenu-dot">•</span>
                <span>HR Confluence 2026</span>
              </button>

              <button
                className={`hrd-registration-subitem ${
                  selectedRegistrationEvent === "festival" && activePage === "festival"
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setSelectedRegistrationEvent("festival");
                  setActivePage("festival");
                }}
              >
                <span className="hrd-submenu-dot">•</span>
                <span>HR Festival 2026</span>
              </button>
            </div>
          )}

          {/* Attendees Dropdown */}
          {item.label === "Attendees List" && (
  <div className={`hrd-registration-submenu ${attendeesOpen ? "open" : ""}`}>
              <button
                className={`hrd-registration-subitem ${
                  selectedAttendeesEvent === "confluence" && activePage === "attendees"
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setSelectedAttendeesEvent("confluence");
                  setActivePage("attendees");
                }}
              >
                <span className="hrd-submenu-dot">•</span>
                <span>HR Confluence 2026</span>
              </button>

              <button
                className={`hrd-registration-subitem ${
                  selectedAttendeesEvent === "festival" && activePage === "attendees-festival"
                    ? "active"
                    : ""
                }`}
                onClick={() => {
                  setSelectedAttendeesEvent("festival");
                  setActivePage("attendees-festival");
                }}
              >
                <span className="hrd-submenu-dot">•</span>
                <span>HR Festival 2026</span>
              </button>
            </div>
          )}

        </React.Fragment>
      ))}
    </div>
  ))}
</nav>

      </aside>

      {/* ---------------- Main content ---------------- */}
      <main className="dash-hrd-main">
        <header className="hrd-topbar hrd-panel">
          <h1>
            {activePage === "registration" ? (
              <>
                Registered Users –
                <span className="hrd-topbar-sub">India HR Confluence 2026</span>
              </>
            ) : activePage === "dashboard" ? (
              "Dashboard"
            ) : activePage === "attendees" || activePage === "attendees-festival" ? (
              "Check-In for Attendees - India HR Confluence 2026"
            ) : activePage === "collaborate" ? (
              "Collaborate List"
            ) : activePage === "gallery" ? (
              "Gallery Management"
            ) : activePage === "community" ? (
              "Community Members"
            ) : activePage === "subscribers" ? (
              "Subscribers"
            ) : (
              ""
            )}
          </h1>

          <button
            type="button"
            className="hrd-logout"
            onClick={() => {
              console.log("logout button clicked");
              localStorage.clear();
              navigate("/admin/login", { replace: true });
            }}
          >
            <LogOut size={14} />
            Logout
          </button>
        </header>

{activePage === "dashboard" ? (
  <DashboardFrontPage onNavigate={setActivePage} />
) : activePage === "registration" ? (
        <section className="hrd-panel">
          <div className="hrd-stats">
            <span className="hrd-pill hrd-pill--total">Total Registered : {total}</span>
            <span className="hrd-pill hrd-pill--sent">Emails Sent : {emailsSentCount}</span>
            <span className="hrd-pill hrd-pill--unsent">
              Emails Unsent : {total - emailsSentCount}
            </span>
            <button className="hrd-pill hrd-pill--export" onClick={handleExportToExcel}>
              <span className="excel-icon-wrap">
                <img src="/assets/excel.png" alt="Excel" className="excel-icon excel-icon--default" />
                <img src="/assets/excel-white.png" alt="Excel" className="excel-icon excel-icon--hover" />
              </span>
              Export To Excel
            </button>
            <button
              className="hrd-pill hrd-pill--bulk"
              onClick={handleBulkSendEmail}
              disabled={bulkSending}
            >
              <Mail size={14} />
              {bulkSending ? "Sending..." : "Sent Bulk Email"}
            </button>
          </div>

          <div className="hrd-actions">
            <button className="hrd-btn hrd-btn--sponsor">
              <img src="/assets/plu.png" alt="Plus" className="plus-icon" />
              Add Bulk Sponsor Users
            </button>
            <button className="hrd-btn hrd-btn--special">
              <img src="/assets/pluss.png" alt="Plus" className="plus-icon" />
              Add Bulk Special Users
            </button>
            <button
              className="hrd-btn hrd-btn--delete"
              onClick={handleBulkDelete}
              disabled={bulkDeleting}
            >
              <img src="/assets/bulk_delete.png" alt="Bulk Delete" className="delete-icon" />
              {bulkDeleting ? "Deleting..." : "Bulk Delete"}
            </button>
          </div>

          {/* Table controls */}
          <div className="hrd-table-controls">
            <label className="hrd-show-entries">
              Show Entries:
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </label>
            <div className="hrd-search">
              <Search size={14} />
              <input
                placeholder="Search..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Table */}
          <div className="hrd-table-wrap">
            {loading ? (
              <p style={{ padding: "20px" }}>Loading registered users...</p>
            ) : error ? (
              <p style={{ padding: "20px", color: "#e0432c" }}>{error}</p>
            ) : (
              <table className="hrd-table">
                <thead>
                  <tr>
                    <th className="hrd-checkbox-col">
                      <label className="hrd-select-all">
                        <input type="checkbox" checked={selectAll} onChange={toggleAll} />
                        <span>Select All</span>
                      </label>
                    </th>
                    <th>S.No</th>
                    <th>Full Name</th>
                    <th>Designation</th>
                    <th>Company</th>
                    <th>Contact</th>
                    <th>Personal Email</th>
                    <th>Official Email</th>
                    <th>Email Status</th>
                    <th>Send Confirmation</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedUsers.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ padding: "20px", textAlign: "center" }}>
                        No registrations yet.
                      </td>
                    </tr>
                  ) : (
                    paginatedUsers.map((u, index) => (
                      <tr key={u.id}>
                        <td className="hrd-checkbox-col">
                          <input
                            type="checkbox"
                            checked={selected.includes(u.id)}
                            onChange={() => toggleOne(u.id)}
                          />
                        </td>
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>
                          <div className="hrd-user-cell">
                            {u.imagePath ? (
                              <img
                                src={`${API_BASE_URL}${u.imagePath}`}
                                alt={u.fullName}
                                className="hrd-avatar hrd-avatar--photo"
                              />
                            ) : (
                              <span className="hrd-avatar">{u.fullName?.charAt(0)}</span>
                            )}
                            {u.fullName}
                          </div>
                        </td>
                        <td>{u.designation}</td>
                        <td>{u.company}</td>
                        <td>{u.contact}</td>
                        <td>{u.personalEmail}</td>
                        <td>{u.officialEmail}</td>
                        <td>
  {u.confirmationSent ? (
    <span className="hrd-status-pill hrd-status-pill--sent">
      ✓ Sent
    </span>
  ) : (
    <span className="hrd-status-pill hrd-status-pill--unsent">
      ✕ UnSent
    </span>
  )}
</td>
    <td>
  <button
    className={`hrd-send-confirm-btn ${
      u.confirmationSent ? "confirmed" : "send"
    }`}
    disabled={sendingId === u.id || u.confirmationSent}
    onClick={() => handleSendConfirmation(u.id)}
  >
    <Send size={13} />
    {sendingId === u.id
      ? "Sending..."
      : u.confirmationSent
      ? "Sent Confirmation"
      : "Send Confirmation"}
  </button>
</td>
                        <td>
                          <div className="hrd-row-actions">
                            <button
                              className="hrd-icon-btn hrd-icon-btn--edit"
                              title="Edit"
                              onClick={() => openEditModal(u)}
                            >
                              <Pencil size={13} />
                              Edit
                            </button>
                            <button
                              className="hrd-icon-btn hrd-icon-btn--delete"
                              title="Delete"
                              onClick={() => handleDelete(u.id)}
                            >
                              <Trash2 size={13} />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>

          {/* Footer / pagination */}
          <div className="hrd-table-footer">
            <span>
              Showing {paginatedUsers.length === 0 ? 0 : (currentPage - 1) * pageSize + 1}
              &ndash;
              {(currentPage - 1) * pageSize + paginatedUsers.length} of {filteredUsers.length} Members
            </span>
            <div className="hrd-pagination">
              <button
                className="hrd-page-btn"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeft size={14} />
              </button>

              {getPageNumbers().map((p, i) =>
                p === "dots-start" || p === "dots-end" ? (
                  <span key={`${p}-${i}`} className="hrd-page-dots">
                    …
                  </span>
                ) : (
                  <button
                    key={p}
                    className={`hrd-page-btn${p === currentPage ? " active" : ""}`}
                    onClick={() => goToPage(p)}
                  >
                    {p}
                  </button>
                )
              )}

              <button
                className="hrd-page-btn"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <ChevronRight size={14} />
              </button>
            </div>
          </div>
        </section>
) : activePage === "attendees" || activePage === "attendees-festival" ? (
  <Attendees selectedEvent={selectedAttendeesEvent} />
) : activePage === "collaborate" ? (
  <CollaborateList />
) : activePage === "gallery" ? (
  <Dashgallery />
) : activePage === "community" ? (
  <CommunityMember />
) : activePage === "subscribers" ? (
  <SubscriberList />
) : null}
      </main>

      {/* ---------------- Edit Modal ---------------- */}
      {editingUser && (
        <div className="hrd-modal-overlay" onClick={closeEditModal}>
          <div className="hrd-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="hrd-modal-title">Edit Registration</h2>

            <form onSubmit={handleEditSubmit} className="hrd-modal-form">
              <div className="hrd-modal-field">
                <label>Full Name</label>
                <input
                  name="fullName"
                  value={editForm.fullName}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Designation</label>
                <input
                  name="designation"
                  value={editForm.designation}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Company</label>
                <input
                  name="company"
                  value={editForm.company}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Contact Number</label>
                <input
                  name="contact"
                  value={editForm.contact}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Personal Email</label>
                <input
                  type="email"
                  name="personalEmail"
                  value={editForm.personalEmail}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Official Email</label>
                <input
                  type="email"
                  name="officialEmail"
                  value={editForm.officialEmail}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-actions">
                <button
                  type="button"
                  className="hrd-modal-btn hrd-modal-btn--cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="hrd-modal-btn hrd-modal-btn--save"
                  disabled={saving}
                >
                  {saving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}